import { makeStyles, Theme } from "@material-ui/core/styles";
import {
  boldFont,
  mediumFont,
  regularFont,
  getRelativeFontSize,
  getCurrentAccentColor,
  getCurrentAccentTextColor,
  lightFont,
  paragraphTextStyle,
  headingTextStyle,
} from "../../../utils/styles";

const checkoutFooterStyles = makeStyles(
  (theme: Theme) => ({
    footerContainer: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#F4F4F4",
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
      border: "1px solid #D2D2D2",
      padding: "20px",
      zIndex: 1000,
    },
    summarySection: {
      marginBottom: "16px",
    },
    summaryRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
      "&:last-child": {
        marginBottom: 0,
      },
    },
    summaryLabel: {
      ...regularFont,
      ...paragraphTextStyle,
      color: "#333",
      fontWeight: 400,
    },
    summaryValue: {
      ...mediumFont,
      ...paragraphTextStyle,
      color: "#333",
      // fontWeight: 600,
    },
    discountValue: {
      ...mediumFont,
      ...paragraphTextStyle,
      color: "#e74c3c",
      fontWeight: 600,
    },
    checkoutButtonContainer: {
      width: "100%",
    },
    buttonRow: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
    },
    backButton: {
      backgroundColor: "#f0f0f0",
      borderRadius: "50px",
      border: "1px solid #D2D2D2",
      padding: "8px 14px",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      minWidth: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        backgroundColor: "#e0e0e0",
        transform: "translateY(-1px)",
      },
      "&:active": {
        transform: "translateY(0px)",
      },
    },
    backButtonText: {
      ...mediumFont,
      fontSize: getRelativeFontSize(2),
      color: "#333",
    },
    checkoutButton: {
      backgroundColor: getCurrentAccentColor(),
      borderRadius: "50px",
      padding: "8px 14px",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      boxShadow: `0 2px 8px ${getCurrentAccentColor()}33`, // 33 = 20% opacity
      "&:hover": {
        backgroundColor: getCurrentAccentColor(),
        transform: "translateY(-2px)",
        boxShadow: `0 6px 16px ${getCurrentAccentColor()}4D`, // 4D = 30% opacity
        filter: "brightness(0.9)",
      },
      "&:active": {
        transform: "translateY(0px)",
        boxShadow: `0 2px 8px ${getCurrentAccentColor()}33`,
        filter: "brightness(0.8)",
      },
    },
    checkoutButtonDisabled: {
    //   backgroundColor: "#ccc",
      cursor: "not-allowed",
      "&:hover": {
        // backgroundColor: "#ccc",
        transform: "none",
      },
    },
    checkoutContent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
    checkoutText: {
      ...boldFont,
      ...paragraphTextStyle,
      color: getCurrentAccentTextColor(),
    },
    itemCountContainer: {
      display: "flex",
      alignItems: "center",
      minWidth: "20px",
      justifyContent: "center",
      gap: "8px",
      backgroundColor: getCurrentAccentTextColor(),
      padding: "4px 10px",
      borderRadius: "20px",
    },
    itemCount: {
      ...mediumFont,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: getCurrentAccentColor(),
      gap: "4px",
      ...paragraphTextStyle,
      ...boldFont,
      letterSpacing: "0.5px",
    },
    itemCountSpan:{
        ...lightFont,
        ...paragraphTextStyle,
        marginTop: "4px",
    },
    arrowIcon: {
      width: "16px",
      height: "16px",
      filter: getCurrentAccentTextColor() === "#ffffff" || getCurrentAccentTextColor() === "white" 
        ? "brightness(0) invert(1)" 
        : "brightness(0)",
    },
    checkoutButtonFlex: {
      flex: 1,
    },
  }),
  { index: 1 }
);


export default checkoutFooterStyles;